import Vue from 'vue';
import Vuex from 'vuex';
import store from '@/services/store';
import Welcome from '@/pages/welcome/Welcome.vue';
import Bus from '@/services/EventBus';

// Setup global vue packages
Vue.use(Vuex);

// Load global components
Vue.component('Modal', () => import('@/components/Modal.vue'));

// Attach our global event bus to the Vue instance
Vue.prototype.$bus = Bus;

// Disable Vue debugging in production
if (process.env.NODE_ENV === 'production') {
    Vue.config.devtools = false;
    Vue.config.debug = false;
    Vue.config.silent = true;
} else {
    Vue.config.devtools = true;
    Vue.config.debug = true;
    Vue.config.silent = false;
}

new Vue({
    store,
    el: '#app',
    render: (h) => h(Welcome)
});
